import { SCORE_SCALE, scoreScaleColor, hexWithAlpha } from '../../../constants/scoreScale';

export { SCORE_SCALE, scoreScaleColor };

export function scoreAccent(value) {
  return scoreScaleColor(value);
}

export function scoreBarFill(value) {
  return scoreScaleColor(value, '#A8A99E');
}

/** Soft badge background derived from the exact score colour. */
export function scoreBadgeBg(value) {
  const color = scoreScaleColor(value, null);
  if (!color) return 'rgba(118,120,108,0.18)';
  return hexWithAlpha(color, 0.18);
}
